import { Tag as AntdTag } from 'antd';
import { Tag as TagModel } from 'src/models';
import { CloseOutlined } from '@ant-design/icons';
import { lightenColor } from 'src/utils';

type InsightTagProps = {
  tag: TagModel;
  onClose?: () => void;
  isSelected?: boolean;
  onClick?: () => void;
};

export const InsightTag = ({
  tag,
  onClose,
  isSelected,
  onClick,
}: InsightTagProps) => {
  const color = tag.meta?.color || '#888888';

  const appearance = isSelected
    ? {
        color,
        backgroundColor: lightenColor(color, 90),
        border: 'none',
        boxShadow: `inset 0 0 0 1px ${lightenColor(color, 70)}, 
                        inset 0 2px 4px ${lightenColor(color, 70)}`,
      }
    : { backgroundColor: 'lightgray', borderColor: 'lightgray' };

  return (
    <AntdTag
      title={tag.name}
      style={{
        maxWidth: '320px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        ...(onClick && { cursor: 'pointer' }),
        ...appearance,
      }}
      {...(onClose && {
        onClose: (e) => {
          e.preventDefault();
          onClose?.();
        },
        closeIcon: <CloseOutlined style={{ color: tag.meta?.color }} />,
      })}
      onClick={onClick}
      className="m-0 inline-flex items-center"
    >
      {tag.name}
    </AntdTag>
  );
};
